var Handlebars = require("/home/admin/gitlab_code/assets/enhancer/user-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<h1 class=\"forget-title\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.resetPassword : stack1), depth0))
    + "</h1>\n<form action=\"/forget\" method=\"post\" role=\"form\" class=\"forget-form\">\n  <div class=\"form-item\">\n    <input id=\"account\" class=\"enhancer-input\" data-type=\"email\" type=\"text\" name=\"account\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.mobileOrEmail : stack1), depth0))
    + "\">\n    <label for=\"account\"></label>\n  </div>\n  <div class=\"form-item\">\n    <button class=\"enhancer-btn\" type=\"submit\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.submit : stack1), depth0))
    + "</button>\n  </div>\n</form>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/forget/forget.html
// module id = 6
// module chunks = 0